import i18nConfig from "~/config/i18n.json"
import type { I18n } from "~/lib/i18n/types"
import { getDefaultLocale } from "~/lib/i18n/utils/get-default"

export default function getCurrency(locale: keyof I18n) {
  return i18nConfig?.[locale]?.currency ?? i18nConfig?.[getDefaultLocale()]?.currency
}
